import {axiosInstance} from "@/app/api";
import {onGetTableResponse} from "@/libs/helper";

const onGetEmailData = async (url: string, body: any): Promise<any> => {
  return await axiosInstance()
    .post(url, body)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;

        return neoresponse;
      }
      return onGetTableResponse();
    })
    .catch((error: any) => {
      return onGetTableResponse();
    });
};

export const emailTemplateService = {
  onGetEmailData
};
